exports.awsUrl = 'https://studio-storage.cupola360.com/'

exports.oauth = {
  facebook: '365952121510507',
  google: '566795342347-han11dd48m0fn6q4lmcqvj84l87cbie1.apps.googleusercontent.com'
}
exports.publicKey = '-----BEGIN PUBLIC KEY-----MIGeMA0GCSqGSIb3DQEBAQUAA4GMADCBiAKBgHCCZeZQcgwFrozAtGi7puIgy113Prdhm9cGl905zLs1UenJH+5P8AboHeO8kr9hGl1gVF5iJV5A6ldTyga2lJLqyk40YoQkbH6gyX2F8IzBhMQqZ83aO85arVc/X+Wy69uZ+PgAgZe1UE8/f4NGbm7A/oyHukW18oueMZ0dIwFXAgMBAAE=-----END PUBLIC KEY-----'
